import { render, staticRenderFns } from "./PageComplaints.vue?vue&type=template&id=56c3681f&"
import script from "./PageComplaints.vue?vue&type=script&lang=ts&"
export * from "./PageComplaints.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports